<template>
  <div id="app">
    <div v-if="$route.meta.noBar">
      <router-view></router-view>
    </div>
    <div v-else>
      <section class="home">
        <div class="top">
          <top ref="top"></top>
        </div>
        <div class="container">
          <left></left>
          <div class="rightcontainer">
            <div class="place" style="display: flex">
              <el-page-header style="line-height: 40px; margin-left: 40px" @back="$router.go(-1)" content></el-page-header>
              <div style="display: flex">
                <span>位置：</span>
                <ul class="placeul">
                  <li>
                    <span href="#">首页</span>
                  </li>
                  <li>
                    <span>{{ $route.meta.title }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <router-view :key="this.$route.fullPath"></router-view>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { BzAjax } from "js/fetch.js";
import { BzStore } from "js/helper";
import Top from "@/components/top";
import Left from "@/components/left";
export default {
  name: "App",
  data() {
    return {
      routekey: 0,
    };
  },
  components: {
    Top,
    Left,
  },
  created() {
    var sUserAgent = navigator.userAgent;
    if (
      sUserAgent.indexOf("Android") > -1 ||
      sUserAgent.indexOf("iPhone") > -1 ||
      sUserAgent.indexOf("iPad") > -1 ||
      sUserAgent.indexOf("iPod") > -1 ||
      sUserAgent.indexOf("Symbian") > -1
    ) {
      location.href = "https://app.ypwsd.com";
    } else {
    }
    this.checkVersion();
  },
  mounted() {
    // this.settop(3543, "缙云县康欣药品零售有限责任公司")
  },
  methods: {
    checkVersion() {
      BzAjax.post("http://os.ypgsp.com/Retail/AppVersion/GetVersion", {
        AppCode: "020",
        AppWebId: -1,
      }).then((res) => {
        if (res) {
          let VersionNumber = BzStore.get("VersionNumber", "");
          if (VersionNumber) {
            if (Number(VersionNumber) < res.VersionNumber) {
              BzStore.set("VersionNumber", res.VersionNumber);
              window.location.reload(true);
            }
          } else {
            BzStore.set("VersionNumber", res.VersionNumber);
          }
        }
      });
    },
  },
};
</script>
<style lang="less">
.rightcontainer {
  width: calc(100vw - 100px);
}
</style>




// WEBPACK FOOTER //
// src/App.vue